module.exports = __webpack_public_path__ + "img/bg-plat.b2506b94.png";